// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__26g6M","head":"ProcedureTableInfo_head__2I4Kw"};